import { Base, Component, Mixins, Prop } from '@/vue-property-decorator'
import AdvertiseImgIndividual from './advertiseImgIndividual'
import BasePropsConfig, { LandscapeProps } from '../components/basePropsConfig'
import BoxCut from '../../components/boxCut'
import MaskMaintain from '../../components/maskMaintain'
import OuterBox from './outerBox'
import style from './style.module.scss'
/** cssSizeType的样式类型 */
export enum LandscapeLeftRightCssSizeType {
  Default = 'default',
  Small = 'small'
}
type Props = LandscapeProps & {
  /** 样式 */
  cssSizeType?: LandscapeLeftRightCssSizeType
}
/** 游戏卡片-横向卡片 */
@Component<LandscapeLeftRight>({
  name: 'LandscapeLeftRight'
})
export default class LandscapeLeftRight extends Mixins<
  Base<unknown, Props>,
  BasePropsConfig
>(Base, BasePropsConfig) {
  /** 样式尺寸类型 */
  public static CssSizeType = LandscapeLeftRightCssSizeType

  @Prop({ default: 'default' })
  protected cssSizeType!: Required<Props>['cssSizeType']

  /** 通过传入原始数据,获取props */
  public static getProps = BasePropsConfig.getProps

  render() {
    const { cssSizeType } = this
    const { isMaintain } = this.cardProps
    return (
      <OuterBox
        class={{
          ['landscape-left-right']: true,
          [style['landscape-left-right']]: true,
          [style[`type-${cssSizeType}`]]: true
        }}
        onClick={this.handleClickCard}
      >
        {/* 放置在box-cut中的元素会被裁剪为圆角 */}
        <BoxCut>
          {/* 渲染广告图片 */}
          <AdvertiseImgIndividual />
          <template slot="cutSuspense">
            {/* 维护状态悬浮层 */}
            {isMaintain && <MaskMaintain />}
          </template>
        </BoxCut>
      </OuterBox>
    )
  }
}
